import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageSet } from "src/pageDefinitions/types";

export type LinearBuyflowState = {
  pageSetName: string;
  isPageSetInit: boolean;
};

const linearBuyflow = createSlice({
  name: "linearBuyflow",
  initialState: {
    pageSetName: null,
    isPageSetInit: false,
  } as LinearBuyflowState,
  reducers: {
    setActivePageSet(state, action: PayloadAction<PageSet>) {
      return {
        pageSetName: action.payload.id,
        isPageSetInit: false,
      };
    },
    setPageSetInit(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        isPageSetInit: action.payload,
      };
    },
  },
});

export const { setActivePageSet, setPageSetInit } = linearBuyflow.actions;

export default linearBuyflow.reducer;
